/**
 * Source: https://github.com/Prismfly/Speed-Improvement-Package
 */
(function () {

    /**
     * SpeedPackage class for managing
     * quick links, instant clicks, and speculation API.
     */
    class SpeedPackage {
  
      /**
       * Default configuration for the SpeedPackage.
       * @private
       */
      #defaults = {
        quickLinkScriptUrl: 'https://unpkg.com/quicklink@2.3.0/dist/quicklink.umd.js',
        instantClickScriptUrl: 'https://unpkg.com/instantclick@3.1.0-2/dist/instantclick.js',
        quickLink: true,
        instantClick: true,
        speculationApi: false,
        speculationType: 'prefetch'
      };
  
      /**
       * Creates a new SpeedPackage instance.
       * @param {Object} options - Configuration options for the SpeedPackage.
       */
      constructor(options) {
        this.options = Object.assign({}, this.#defaults, options);
        this.init();
      }
  
      /**
       * Initializes the SpeedPackage based on the provided options.
       * @async
       */
      async init() {
        const options = [
          {
            enabled: this.options.quickLink,
            scriptUrl: this.options.quickLinkScriptUrl,
            initMethod: this.initQuickLink.bind(this)
          },
          {
            enabled: this.options.instantClick,
            scriptUrl: this.options.instantClickScriptUrl,
            initMethod: this.initInstantClick.bind(this)
          },
          {
            enabled: this.options.speculationApi,
            initMethod: this.initSpeculationApi.bind(this)
          }
        ];
  
        for (const option of options) {
          if (!option.enabled) {
            continue;
          }
  
          if (option.scriptUrl) {
            await this.load(option.scriptUrl);
          }
  
          if (document.readyState !== 'loading') {
            option.initMethod();
          } else {
            document.addEventListener('DOMContentLoaded', option.initMethod);
          }
        }
      }
  
      /**
       * Initializes QuickLink if it's enabled and loaded.
       */
      initQuickLink() {
        if (!window.quicklink) {
          return;
        }
        window.quicklink.listen();
      }
  
      /**
       * Initializes InstantClick if it's enabled and loaded.
       */
      initInstantClick() {
        if (!window.InstantClick) {
          return;
        }
        window.InstantClick.init();
      }
  
      /**
       * Initializes Speculation API if it's enabled and supported.
       */
      initSpeculationApi() {
        if (HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
          const script = document.createElement('script');
          script.type = 'speculationrules';
  
          const content = {};
          content[this.options.speculationType] = [
            {
              "source": "document",
              "where": {
                "and": [
                  { "href_matches": "/*" },
                  { "not": { "href_matches": "/logout" } },
                  { "not": { "href_matches": "/account/logout" } },
                  { "not": { "href_matches": "/cart" } },
                  { "not": { "selector_matches": ".no-prerender" } }
                ]
              },
              "eagerness": "moderate"
            }
          ];
  
          script.textContent = JSON.stringify(content);
          document.body.appendChild(script);
        }
      }
  
      /**
       * Loads a script from a given URL.
       * @param {string} scriptUrl - The URL of the script to load.
       * @returns {Promise} A promise that resolves when the script is loaded.
       */
      load(scriptUrl) {
        return new Promise((resolve, reject) => {
          const s = document.createElement('script');
          s.defer = true;
          s.src = scriptUrl;
          s.addEventListener('load', () => {
            resolve(true);
          });
          s.addEventListener('error', () => {
            reject('There\'s an issue loading the script.');
          });
          document.head.appendChild(s);
        });
      }
    }
  
    /**
     * Expose the SpeedPackage class to the global scope.
     */
    window.SpeedPackage = SpeedPackage;
  
  }());